import { howToRoutes } from '@/HowTo/howto.routes';
const howToModule = {
    routes: howToRoutes
};
export default howToModule;
